<template>
	<div>
		<card>
			<div class="row">
				<label class="col-form-label col-md-12">Введите ID объекта</label>
				<div class="col-md-12">
					<div class="form-group">
						<div class="mb-0">
							<input type="text" placeholder="ID объекта" class="form-control" v-model="obj_id">
						</div>
					</div>
				</div>
			</div>
			<button class="btn btn-simple btn-success" @click="updateObject()">Сохранить</button>
		</card>
	</div>
</template>
<script>
import Card from '../components/Cards/Card.vue';

export default {
	name: 'client_obj_edit-page',
	components: {
Card

	},
	data() {
		return {
			obj_id: '',
		};
	},
	methods: {
		updateObject(){
			this.$GVO.ApiCall('UPD_SERVICE_OBJ',{obj:'services',flt:{'id':this.$route.query.id},uData:{'service_id':this.$route.query.service_id,'obj_id':this.obj_id}})
			.then((objApi) => {
				if(objApi.success === true){
					location.href = '/data/clients/id/'+this.$route.params.client_id;
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
	},
	mounted() {
		this.obj_id = this.$route.query.obj_id;
	}
};
</script>
<style>
</style>
